import { useQuery } from '@tanstack/react-query';

import { organizationAdminsApi } from '../../api/lib/organization-admins';
import { organizationAdminsKeys } from '../../api/query-keys/organization-admins';
import { OrganizationAdmin } from '../../api/types/organization-admin';

import { ApiError } from '@/types/interfaces/api-error';

export const useOrganizationAdmins = () => {
  return useQuery<OrganizationAdmin[], ApiError>({
    queryKey: organizationAdminsKeys.list(),
    queryFn: organizationAdminsApi.fetchOrganizationAdmins,
  });
};
